import type { FC } from 'react';
import classNames from 'classnames';

import { isDefined } from 'app/utils/types';

import style from './style.module.scss';

interface Props {
  value: any;
  greyedOutIfNull?: boolean;
  displayFunction?: (val: any) => string;
}

const StatValue: FC<Props> = ({ value, displayFunction, greyedOutIfNull = true }) => {
  if (isDefined(value)) {
    if (displayFunction) {
      return displayFunction(value);
    }
    return value;
  }

  return <span className={classNames({ [style.noValue]: greyedOutIfNull })}>-</span>;
};

StatValue.displayName = 'StatValue';

export default StatValue;
